// @flow

import { shouldDisableAddressAndPhone } from '@tectonics/prs/merchant/config';
import { getMerchant } from '@tectonics/prs/incoming-payment';
import { type IncomingPayment } from './types';

export function shouldHideCustomerAddressAndPhoneFields(incomingPayment: IncomingPayment): boolean {
  return shouldDisableAddressAndPhone(getMerchant(incomingPayment));
}
